import React from 'react';
import { Box, Chip, Stack, Divider } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const docTyp = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: '수주', label: '수주', color: 'success' },
  { id: 2, value: '기술', label: '기술', color: 'info' },
  { id: 3, value: '세금', label: '세금', color: 'secondary' },
];

const ApprovalStatusList = ({ searchDocTyp, onChangeDocTyp }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItem: 'center',
        m: 1,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        <Box>
          {docTyp &&
            docTyp.map((st, index) => (
              <Chip
                sx={{ mr: 2 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={st.value === searchDocTyp ? 'contained' : 'outlined'}
                color={st.color}
                onClick={() => onChangeDocTyp(st.value)}
              />
            ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default ApprovalStatusList;
